<div class="popup-content waybill-complete-popup">

<div class="popup-header">
  <div class="d-flex ">
    <h2 class="popup-title">
      {{ mode === 'CREATE' ? 'Nuovo Borderò' : (readOnly ? 'Dettaglio Controllo Fila' : 'Aggiorna Borderò') }} {{ loadingListCode }}
    </h2>

    <!-- Toggle modalità -->
    <div class="header-toggle" *ngIf="step === 1 || mode === 'EDIT'">
      <div class="statistics-toggle-group">

        <button type="button"
        class="statistics-toggle-btn"
        [disabled]="mode === 'EDIT'"
        [class.active]="loadingListType === 'DEPARTURE'"
        (click)="onLoadingListTypeChange('DEPARTURE')">
          <i class="fas fa-circle-up"></i>
          DI PARTENZA
        </button>

        <button type="button"
        class="statistics-toggle-btn"
        [disabled]="mode === 'EDIT' || mode === 'CREATE'"
        [class.active]="loadingListType === 'ARRIVAL'"
        (click)="onLoadingListTypeChange('ARRIVAL')">
          <i class="fas fa-circle-down"></i>
          DI ARRIVO
        </button>

      </div>
    </div>

    <div class="link-trip-wrap" *ngIf="canEditLink || linkMode === 'ACTIVE'">

      <button type="button"
              class="btn btn-primary link-toggle-btn"
              *ngIf="linkMode === 'NONE' && canEditLink"
              [disabled]="!readyToLinkTrip"
              (click)="openLinkInput()"
              [matTooltip]="readyToLinkTrip ? 'Abbina a un viaggio o documento di trasporto' : 'Seleziona prima magazzino, tour group e vettore'"
              matTooltipPosition="above">
        <i class="fas fa-link"></i>
      </button>

      <div class="link-input-row" *ngIf="linkMode === 'INPUT' && !pendingTripLink">
        <input type="text"
               class="form-control link-code-input"
               [(ngModel)]="linkCodeValue"
               [ngModelOptions]="{ standalone: true }"
               placeholder="Codice TIP o documento di trasporto..."
               [disabled]="resolvingLink"
               (keyup.enter)="confirmLink()">

        <button type="button"
                class="btn btn-primary link-confirm-btn"
                [disabled]="!linkCodeValue?.trim() || resolvingLink"
                (click)="confirmLink()"
                matTooltip="Conferma abbinamento">
          <i class="fas" [ngClass]="resolvingLink ? 'fa-spinner fa-spin' : 'fa-check'"></i>
        </button>

        <button type="button"
                class="btn btn-outline-secondary link-cancel-btn"
                [disabled]="resolvingLink"
                (click)="cancelLinkInput()"
                matTooltip="Annulla">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="link-force-confirm" *ngIf="pendingTripLink">
        <div class="link-force-confirm-text">
          <i class="fas fa-triangle-exclamation me-2"></i>
          Il viaggio <b>{{ pendingTripLink.tripCode }}</b> ha vettore
          <b>{{ pendingTripLinkCarrierName }}</b>, diverso da quello selezionato
          (<b>{{ pendingTripLinkCurrentCarrierName }}</b>). Vuoi forzare comunque il collegamento?
          Il vettore del borderò passerà a quello del viaggio e resterà bloccato finché non rimuovi l'abbinamento.
        </div>
        <div class="link-force-confirm-actions">
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="cancelForceTripLink()">
            No, annulla
          </button>
          <button type="button" class="btn btn-sm btn-primary" (click)="confirmForceTripLink()">
            Sì, forza il collegamento
          </button>
        </div>
      </div>

      <span class="link-active-badge" [class.locked]="!canEditLink" *ngIf="linkMode === 'ACTIVE'">
        <i class="fas" [ngClass]="canEditLink ? 'fa-link' : 'fa-lock'"></i>
        Viaggio: <b>{{ linkCodeValue }}</b>

        <button type="button"
                class="link-remove-btn"
                *ngIf="canEditLink"
                (click)="removeLink()"
                matTooltip="Rimuovi abbinamento"
                matTooltipPosition="above">
          <i class="fas fa-xmark"></i>
        </button>
      </span>

      <div class="link-resolve-error" *ngIf="linkResolveError">
        <i class="fas fa-triangle-exclamation me-1"></i>{{ linkResolveError }}
      </div>
    </div>

  </div>
  <div>
    <button type="button" class="btn-close" (click)="close()" aria-label="Close">
      <i class="fas fa-times"></i>
    </button>
  </div>
</div>


  <div class="popup-body" [class.step-1]="step === 1" [class.step-2]="step === 2">
    <div *ngIf="step === 1">
    <form [formGroup]="form" (ngSubmit)="save()">

        <!-- MAGAZZINO + EXTRA -->
        <div class="mb-4">
        <h5 class="section-title">
            <i class="fas fa-warehouse me-2"></i>
            Magazzino
        </h5>

        <div class="row g-3 ">
            <!-- Magazzino -->
            <div class="col-md-8">

            <ng-select
              class="filter-ng-select filter-ng-select-warehouse"
              [class.is-invalid]="form.get('warehouseCode')?.touched && form.get('warehouseCode')?.invalid"
              formControlName="warehouseCode"
              [items]="data.warehouses"
              bindLabel="warehouseName"
              bindValue="warehouseCode"
              [clearable]="!isSingleWarehouse"
              [searchable]="true"
              [readonly]="isSingleWarehouse"
              [searchFn]="searchWarehouseFn"
              appendTo="body"
              notFoundText="Nessun magazzino trovato"
              placeholder="Seleziona il magazzino di partenza">

              <ng-template ng-option-tmp let-item="item">
                <span class="status-option">
                  <i class="fas fa-warehouse me-2"></i>
                  <span>{{ item.warehouseName }}<ng-container *ngIf="item.warehouseShortName"> ({{ item.warehouseShortName }})</ng-container></span>
                </span>
              </ng-template>

              <ng-template ng-label-tmp let-item="item">
                <span class="status-option">
                  <i class="fas fa-warehouse me-2"></i>
                  <span>{{ item.warehouseName }}<ng-container *ngIf="item.warehouseShortName"> ({{ item.warehouseShortName }})</ng-container></span>
                </span>
              </ng-template>
            </ng-select>

            <div *ngIf="form.get('warehouseCode')?.touched && form.get('warehouseCode')?.invalid"
                class="invalid-feedback d-block">
                Seleziona un magazzino
            </div>
            </div>

            <!-- Extra switch -->
            <div class="col-md-4" *ngIf="isExtraVisible">
            <div class="extra-switch-wrap">
                <span class="extra-label" [class.on]="form.get('extra')?.value">
                {{ form.get('extra')?.value ? 'Extra attivo' : 'Extra disattivo' }}
                </span>

                <label class="switch">
                <input type="checkbox" formControlName="extra">
                <span class="slider"></span>
                </label>
            </div>

            <small class="text-muted d-block mt-1">
                <i class="fas fa-info-circle me-1"></i>
                Se attivo, mostra tutti i vettori
            </small>
            </div>
        </div>
        </div>



        <!-- TOUR GROUPS -->
        <div class="mb-4">
          <h5 class="section-title">
            <i class="fas fa-route me-2"></i>
            Tour routing group
          </h5>

          <div formArrayName="tourGroupIds" class="tour-groups-list">

            <div class="tour-group-row" *ngFor="let ctrl of tourGroupIdsArray.controls; let i = index">
                <div class="tour-row-layout">

                    <!-- Numero -->
                    <div class="tour-index">
                    {{ i + 1 }}
                    </div>

                    <!-- Select -->
                    <div class="tour-select-wrap">
                    <ng-select
                      class="filter-ng-select filter-ng-select-tourgroup filter-ng-select-lockable"
                      [class.is-invalid]="ctrl.touched && ctrl.invalid"
                      [formControlName]="i"
                      [items]="tourGroupOptions[i] || []"
                      bindLabel="tourRoutingGroupName"
                      bindValue="tourRoutingGroupId"
                      [clearable]="false"
                      [searchable]="true"
                      [readonly]="!form.get('warehouseCode')?.value"
                      [loading]="loadingTours"
                      [searchFn]="searchTourGroupFn"
                      (change)="onTourGroupChanged()"
                      appendTo="body"
                      loadingText="Caricamento tour group..."
                      notFoundText="Nessun tour group trovato"
                      placeholder="Seleziona il tour group">

                      <ng-template ng-option-tmp let-item="item">
                        <span class="status-option">
                          <i class="fas fa-route me-2"></i>
                          <span>{{ item.tourRoutingGroupName }}</span>
                        </span>
                      </ng-template>

                      <ng-template ng-label-tmp let-item="item">
                        <span class="status-option">
                          <i class="fas fa-route me-2"></i>
                          <span>{{ item.tourRoutingGroupName }}</span>
                        </span>
                      </ng-template>
                    </ng-select>

                    <div *ngIf="ctrl.touched && ctrl.invalid" class="invalid-feedback d-block">
                        Seleziona un tour group
                    </div>

                    <!-- <small class="text-muted d-block mt-1">
                        <i class="fas fa-info-circle me-1"></i>
                        Seleziona uno o più gruppi tour.
                    </small> -->
                    </div>

                    <!-- Bottoni -->
                    <div class="tour-actions">
                    <button type="button"
                            class="btn btn-outline-primary btn-icon"
                            (click)="addTourGroup()"
                            [disabled]="!canAddMoreTours(i)">
                        <i class="fas fa-plus"></i>
                    </button>

                    <button type="button"
                            class="btn btn-outline-danger btn-icon"
                            (click)="removeTourGroup(i)"
                            [disabled]="tourGroupIdsArray.length === 1">
                        <i class="fas fa-minus"></i>
                    </button>
                    </div>

                </div>


              <!-- warning se non puoi aggiungere altri -->
              <!-- <div *ngIf="i === tourGroupIdsArray.length - 1 && !hasAnyTourLeft()"
                   class="alert alert-light border mt-3 mb-0 small">
                <i class="fas fa-ban me-2 text-muted"></i>
                Nessun altro tour group disponibile da aggiungere.
              </div> -->
            </div>

          </div>
        </div>

        <div class="mb-4">
  <div class="row g-3 align-items-start">

    <!-- CARRIER -->
    <div class="col-md-8">
      <h5 class="section-title">
        <i class="fas fa-truck me-2"></i>
        Vettore
        <i class="fas fa-lock ms-2 text-primary" style="font-size: 0.85rem;"
           *ngIf="isCarrierLockedByTrip"
           matTooltip="Vettore bloccato: deriva dal viaggio collegato"
           matTooltipPosition="above"></i>
      </h5>

      <!-- Vettori del/dei tour group selezionati (lista "carriers", come prima) -->
      <ng-select
        class="filter-ng-select filter-ng-select-carrier filter-ng-select-lockable"
        [class.is-invalid]="(form.get('carrierCode')?.touched && form.get('carrierCode')?.invalid) || (linkedTripCarrierMismatch || carrierMismatchNeedsDecision)"
        formControlName="carrierCode"
        [items]="carriers"
        bindLabel="carrierName"
        bindValue="carrierCode"
        [clearable]="false"
        [searchable]="true"
        [readonly]="loadingCarriers || carriers.length === 0 || isCarrierLockedByTrip"
        [loading]="loadingCarriers"
        [searchFn]="searchCarrierFn"
        appendTo="body"
        loadingText="Caricamento vettori..."
        notFoundText="Nessun vettore trovato"
        placeholder="Seleziona il vettore">

        <ng-template ng-option-tmp let-item="item">
          <span class="status-option">
            <i class="fas fa-truck me-2"></i>
            <span>{{ item.carrierName }}</span>
          </span>
        </ng-template>

        <ng-template ng-label-tmp let-item="item">
          <span class="status-option">
            <i class="fas fa-truck me-2"></i>
            <span>{{ item.carrierName }}</span>
          </span>
        </ng-template>
      </ng-select>

      <div *ngIf="form.get('carrierCode')?.touched && form.get('carrierCode')?.invalid && !carrierMismatchNeedsDecision"
           class="invalid-feedback d-block">
        Seleziona un vettore
      </div>

      <div class="link-force-confirm mt-2" *ngIf="carrierMismatchNeedsDecision">
        <div class="link-force-confirm-text">
          <i class="fas fa-triangle-exclamation me-2"></i>
          Il tour group selezionato non prevede il vettore del viaggio collegato
          (<b>{{ linkedTripCarrierName || linkedTripCarrierCode }}</b>). Vuoi forzare
          comunque quel vettore, oppure rimuovere il collegamento al viaggio
          <b>{{ linkedTripCode }}</b>?
        </div>
        <div class="link-force-confirm-actions">
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="removeLinkFromMismatch()">
            Rimuovi collegamento
          </button>
          <button type="button" class="btn btn-sm btn-primary" (click)="confirmForceCarrierFromMismatch()">
            Forza vettore del viaggio
          </button>
        </div>
      </div>
    </div>

    <!-- TARGA -->
    <div class="col-md-4">
      <h5 class="section-title">
        <i class="fas fa-id-card me-2"></i>
        Targa rimorchio
      </h5>

      <div class="position-relative">
        <input type="text"
               class="form-control ps-5 custom-input"
               formControlName="plate"
               maxlength="7"
               (input)="onPlateInput()"
               [class.is-invalid]="form.get('plate')?.touched && form.get('plate')?.invalid"
               placeholder="Targa rimorchio">
        <i class="fas fa-truck position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
      </div>

      <div *ngIf="form.get('plate')?.touched && form.get('plate')?.hasError('required')"
           class="invalid-feedback d-block">
        Inserisci la targa rimorchio
      </div>
    </div>

  </div>
</div>


      </form>
      </div>
  



<div *ngIf="step === 2 && importView === 'NONE'" class="items-step-wrap" [class.is-loading]="loadingItemsSpinner">

  <!-- RIEPILOGO (fisso) -->
  <div class="items-summary-card">
    <div class="d-flex flex-wrap gap-3 align-items-center justify-content-between">
      <div class="summary-left">
        <div class="summary-title">
          <i class="fas fa-list-check me-2"></i>
          <b class="me-2">Colli</b>
          <span class="badge items-counter-badge me-2">
            {{ selectedCount }}/{{ totalCount }}
          </span>
          <span *ngIf="withoutManifestCount > 0" class="badge without-manifest-counter-badge me-2"
                matTooltip="Colli ricevuti senza manifesto" matTooltipPosition="above">
            Non affidati: {{ withoutManifestCount }}
          </span>
          <!-- <span *ngIf="itemsCountOriginal != null && loadingListType === 'DEPARTURE'" style="font-weight: normal;">
            (su <strong style="color:#0d6efd;">{{itemsCountOriginal}}</strong> disponibili originariamente)
          </span> -->
        </div>
        <div class="summary-sub">
          <span class="text-muted summary-one-line">
            <span class="summary-item"
                  [matTooltip]="'Tour: ' + (selectedTourGroupNames || tourGroupNames )"
                  matTooltipPosition="above">
              Tour: <b class="ellipsis">{{ selectedTourGroupNames || tourGroupNames }}</b>
            </span>

            <span class="dot">•</span>

            <span  *ngIf="loadingListType === 'DEPARTURE'" class="summary-item"
                  [matTooltip]="'Magazzino: ' + (warehouseName || '-')"
                  matTooltipPosition="above">
              Magazzino: <b class="ellipsis">{{ warehouseName || '-' }}</b>
            </span>

            <div class="form-row" *ngIf="loadingListType === 'ARRIVAL'">
              <label>Magazzino arrivo</label>
              <select class="form-control"
                [disabled]="true"
                [ngModel]="selectedWarehouseCode">
                <option [ngValue]="selectedWarehouseCode">
                  {{ getWarehouseNameArrivalByCode(selectedWarehouseCode) }}
                </option>
              </select>


              <small *ngIf="possibleWarehouses.length === 0" class="text-muted">
                Nessun magazzino disponibile.
              </small>
            </div>

            <span class="dot">•</span>

            <span class="summary-item"
                  [matTooltip]="'Vettore: ' + (carrierName || '-')"
                  matTooltipPosition="above">
              Vettore: <b class="ellipsis">{{ carrierName || '-' }}</b>
            </span>

            <span class="dot">•</span>

            <span class="summary-item"
                  [matTooltip]="'Targa rimorchio: ' + (form.value.plate || '-')"
                  matTooltipPosition="above">
              Targa rimorchio: <b class="ellipsis">{{ form.value.plate || '-' }}</b>
            </span>

            <span class="dot">•</span>

            <span class="summary-item"
                  [matTooltip]="'Tipo: ' + (loadingListType === 'DEPARTURE' ? 'Partenza' : 'Arrivo')"
                  matTooltipPosition="above">
              Tipo:
              <b class="ellipsis">{{ loadingListType === 'DEPARTURE' ? 'Partenza' : 'Arrivo' }}</b>
            </span>
          </span>
        </div>

      </div>
    </div>

    <!-- KPI -->
    <div class="row g-3 mt-1">
      <div class="col-md-6">
        <div class="kpi-line">
          <div class="kpi-label">
            <i class="fas fa-weight-hanging me-1"></i>
            Peso selezionato: <b>{{ totalSelectedWeightKg | number:'1.0-2' }} kg</b>
          </div>
          <div class="progress">
            <div class="progress-bar" role="progressbar" [style.width.%]="weightPct">
              {{ weightPct }}%
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="kpi-line">
          <div class="kpi-label">
            <i class="fas fa-cube me-1"></i>
            Volume selezionato: <b>{{ totalSelectedVolumeM3 | number:'1.0-3' }} m³</b>
          </div>
          <div class="progress">
            <div class="progress-bar" role="progressbar" [style.width.%]="volumePct">
              {{ volumePct }}%
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="summary-actions d-flex gap-2 mt-2">
    <button type="button" class="btn btn-outline-primary bt-small" [disabled]="!canToggleItems" (click)="selectAll()">
      <i class="fas fa-check-double me-2"></i>Seleziona tutto
    </button>
    <button type="button" class="btn btn-outline-secondary bt-small" [disabled]="!canToggleItems" (click)="deselectAll()">
      <i class="fas fa-ban me-2"></i>Deseleziona tutto
    </button>
  </div> -->

  <div class="summary-actions d-flex align-items-center justify-content-between gap-2 mt-2">

    <!-- Sinistra: bottoni -->
    <div class="d-flex gap-2">
      <button type="button" class="btn btn-outline-primary bt-small"
              [disabled]="!canToggleItems" (click)="selectAll()">
        <i class="fas fa-check-double me-2"></i>Seleziona tutto
      </button>

      <button type="button" class="btn btn-outline-secondary bt-small"
              [disabled]="!canToggleItems" (click)="deselectAll()">
        <i class="fas fa-ban me-2"></i>Deseleziona tutto
      </button>

    </div>

    <!-- Destra: search barcode -->
    <div class="d-flex align-items-center">
      <!-- Import Excel di barcode (solo borderò di partenza modificabili) -->
      <i *ngIf="canImportExcel"
         class="fas fa-file-import import-icon me-3"
         (click)="openImportIntro()"
         matTooltip="Aggiungi colli al borderò: importali da Excel"></i>
      <i class="fas fa-file-excel excel-icon me-3"
        [class.disabled]="!visibleItems?.length"
        (click)="visibleItems?.length && exportToExcel()"
        matTooltip="Esporta Excel">
      </i>
      <div class="filter-group urgency-filter"
          style="align-content: center; padding-right:10px;"
          (click)="toggleUrgencyFilter()">

        <span class="urgency-badge-filter"
              [class.active]="onlyUrgent"
              [class.inactive]="!onlyUrgent"
              matTooltip="Filtra solo colli urgenti">
          <span class="urgency-label">URGENTE</span>
        </span>
      </div>
      <!-- Filtro colli aggiunti in arrivo (solo borderò in arrivo o vista con tutte le date) -->
      <!-- Filtro colli aggiunti in arrivo (solo borderò in arrivo o vista con tutte le date) -->
      <div class="filter-group"
          *ngIf="showAddedOnArrival"
          style="align-content: center; padding-right:10px;"
          (click)="toggleAddedOnArrivalFilter()">
        <span class="urgency-badge-filter added-arrival-filter-badge"
              [class.active]="onlyAddedOnArrival"
              [class.inactive]="!onlyAddedOnArrival"
              [matTooltip]="(onlyAddedOnArrival ? 'Rimuovi filtro: ' : 'Filtra solo i ') + 'colli aggiunti in arrivo (' + addedOnArrivalCount + ')'"
              matTooltipPosition="above">
          <i class="fas fa-plus"></i>
          <span class="urgency-label">IN ARRIVO</span>
        </span>
      </div>

      <!-- Filtro bolle non inviate al vettore -->
      <button type="button"
              class="icon-filter-btn icon-filter-btn--not-sent me-2"
              *ngIf="showWaybillSent"
              [class.active]="onlyWaybillNotSent"
              (click)="toggleWaybillNotSentFilter()"
              [matTooltip]="(onlyWaybillNotSent ? 'Rimuovi filtro: ' : 'Filtra solo i ') + 'colli con bolla non inviata al vettore (' + waybillNotSentCount + ')'"
              matTooltipPosition="above">
        <span class="mail-not-sent-ico">
          <i class="fas fa-envelope"></i>
          <i class="fas fa-xmark mail-not-sent-x"></i>
        </span>
      </button>
      <div class="barcode-search ms-auto">
        <i class="fas fa-search search-ico"></i>

        <input type="text"
              class="form-control barcode-input"
              placeholder="Cerca per barcode..."
              [ngModel]="barcodeFilter"
              (ngModelChange)="onBarcodeFilterChange($event)"
              [disabled]="loadingItems || !validItems?.length">

        <button type="button"
                class="btn btn-link clear-btn"
                (click)="clearBarcodeFilter()"
                [disabled]="!barcodeFilter">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>
  </div>

  <div class="text-center mt-3" *ngIf="loadingItemsSpinner">
    <div class="spinner-border text-primary" role="status"></div>
  </div>

  <!-- Esito import Excel: i colli sono aggiunti solo in interfaccia finché non si salva -->
  <div class="import-added-banner mt-2" *ngIf="importAddedCount > 0">
    <i class="fas fa-circle-check me-2"></i>
    <span><b>{{ importAddedCount }}</b> {{ importAddedCount === 1 ? 'collo aggiunto' : 'colli aggiunti' }} dall'Excel.
      Ricorda di <b>{{ mode === 'CREATE' ? 'creare' : 'salvare' }} il borderò</b> per confermare.</span>
    <button type="button" class="import-banner-close ms-auto" (click)="dismissImportBanner()" aria-label="Chiudi">
      <i class="fas fa-xmark"></i>
    </button>
  </div>

  <!-- LISTA SCROLLABILE (solo qui) -->
  <div class="items-list-scroll mt-2">
    <div class="items-list">
      <div class="item-row"
           *ngFor="let it of visibleItems"
           [class.selected]="it.selected"
           [class.without-manifest]="it.parcelWithoutManifest"
           [class.added-on-arrival]="isAddedOnArrival(it)"
           [class.sent-to-carrier]="isWaybillSent(it)"
           [class.imported-from-excel]="it.importedFromExcel"
           [class.disabled]="!canToggleItems"
           (click)="canToggleItems && toggleItem(it)">

        <div class="item-check">
          <input type="checkbox"
                 class="form-check-input"
                 [checked]="it.selected"
                 [disabled]="!canToggleItems"
                 (click)="$event.stopPropagation()"
                 (click)="canToggleItems && toggleItem(it)">
          <!-- Bolla inviata al vettore: data e destinatari nel tooltip -->
          <span *ngIf="isWaybillSent(it)"
                class="waybill-sent-icon"
                [matTooltip]="getWaybillSentTooltip(it)"
                matTooltipClass="waybill-sent-tooltip"
                matTooltipPosition="right"
                (click)="$event.stopPropagation()">
            <i class="fas fa-envelope-circle-check"></i>
          </span>
          <!-- Bolla non ancora inviata al vettore (solo colli affidati) -->
          <span *ngIf="isWaybillNotSent(it)"
                class="waybill-not-sent-icon"
                [matTooltip]="getWaybillNotSentTooltip(it)"
                matTooltipPosition="right"
                (click)="$event.stopPropagation()">
            <span class="mail-not-sent-ico">
              <i class="fas fa-envelope"></i>
              <i class="fas fa-xmark mail-not-sent-x"></i>
            </span>
          </span>
        </div>

        <div class="item-main d-flex justify-content-between w-100">
          <div class="item-left w-100">

            <div class="item-top-row d-flex align-items-center">
              <div class="item-title d-flex align-items-center" style="width:190px;">
                <span class="parcel-code">{{ it.parcelCode }}</span>
                <span *ngIf="it.importedFromExcel" class="imported-badge ms-2"
                      matTooltip="Aggiunto da import Excel (non ancora salvato)">
                  <i class="fas fa-file-import"></i>
                </span>
                <!-- Collo aggiunto in arrivo: link a Gestione Colli TP filtrata per magazzino di arrivo e collo -->
                <button type="button"
                        *ngIf="isAddedOnArrival(it)"
                        class="added-arrival-link ms-2"
                        (click)="openParcelInOverview(it, $event)"
                        matTooltip="Aggiunto in arrivo – apri in Gestione Colli TP"
                        matTooltipPosition="above">
                  <i class="fas fa-external-link-alt"></i>
                </button>
              </div>

              <div class="item-sub text-muted ms-2 d-flex align-items-center gap-2">
                <div style="width:250px;">
                  Peso: <b>{{ it.weightKgNum | number:'1.0-2' }} kg</b>
                  <span>•</span>
                  Volume: <b>{{ it.volumeM3Num | number:'1.0-3' }} m³</b>
                </div>

                <span class="tour-badge ms-3" style="width:100px;">
                  {{ it.tourRoutingGroupName }}
                </span>

                <span class="tour-badge ms-3">
                  {{ it.parcelPalletType }}
                </span>
              </div>
            </div>

            <div class="item-extra-row text-muted">
              <span class="extra-info">
                <i class="fas fa-calendar-alt me-1"></i>
                Affido:
                <b>{{ it.parcelDate ? (it.parcelDate | date:'dd/MM/yy HH:mm') : '-' }}</b>
              </span>

              <span class="extra-sep">•</span>

              <span class="extra-info">
                <i class="fas fa-clock me-1"></i>
                Consegna stimata:
                <b>{{ it.parcelEstimatedDeliveryDate ? (it.parcelEstimatedDeliveryDate | date:'dd/MM/yy HH:mm') : '-' }}</b>
              </span>

              <span class="extra-sep">•</span>

              <span class="extra-info">
                <i class="fas fa-map-marker-alt me-1"></i>
                Regione:
                <b>{{ it.regionAcronym || '-' }}</b>
              </span>

              <span class="extra-sep">•</span>

              <span class="extra-info">
                <i class="fas fa-user me-1"></i>
                Cliente:
                <b>{{ it.clientAcronym || '-' }}</b>
              </span>
            </div>

          </div>

          <div class="item-right justify-content-between">
            <span *ngIf="it.urgencyCode"
                  class="urgency-badge-item ms-2">
              <span class="urgency-label">URGENTE</span>
            </span>
            <div class="item-status-col">
              <span class="badge status-badge text-center"
                    [class.validated]="loadingListType === 'DEPARTURE' ? it.selected : (getArrivalStatusClass(it) === 'validated')"
                    [class.pending]="loadingListType === 'DEPARTURE' ? (!it.selected && !isDepartureNotLoaded(it)) : (getArrivalStatusClass(it) === 'pending')"
                    [class.not-loaded]="loadingListType === 'DEPARTURE' ? isDepartureNotLoaded(it) : (getArrivalStatusClass(it) === 'not-loaded')"
                    [class.not-arrived]="loadingListType !== 'DEPARTURE' && (getArrivalStatusClass(it) === 'not-arrived')"
                    [class.without-manifest]="it.parcelWithoutManifest">
                <i class="fas"
                  [class.fa-check]="it.selected"
                  [class.fa-circle]="!it.selected"></i>
                {{
                  it.parcelWithoutManifest
                    ? 'NON AFFIDATO'
                    : loadingListType === 'DEPARTURE'
                    ? (it.selected ? 'CARICATO' : isDepartureNotLoaded(it) ? 'NON CARICATO' : 'IN SOSPESO')
                    : getArrivalStatusLabel(it)
                }}
              </span>

              <div class="item-dates" *ngIf="getItemLoadedAt(it) || getItemArrivedAt(it)">
                <span class="item-date item-date--loaded"
                      *ngIf="getItemLoadedAt(it) as d"
                      [class.is-primary]="loadingListType === 'DEPARTURE'"
                      [matTooltip]="'Caricato il ' + (d | date:'dd/MM/yyyy HH:mm')"
                      matTooltipPosition="left">
                  <i class="fas fa-arrow-up"></i>{{ d | date:'dd/MM/yy HH:mm' }}
                </span>

                <span class="item-date item-date--arrived"
                      *ngIf="getItemArrivedAt(it) as d"
                      [class.is-primary]="loadingListType === 'ARRIVAL'"
                      [matTooltip]="'Arrivato il ' + (d | date:'dd/MM/yyyy HH:mm')"
                      matTooltipPosition="left">
                  <i class="fas fa-arrow-down"></i>{{ d | date:'dd/MM/yy HH:mm' }}
                </span>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
  </div>
</div>
<!-- =================== IMPORT EXCEL: caricamento + anteprima colli =================== -->
<div *ngIf="step === 2 && importView !== 'NONE'" class="items-step-wrap import-wrap">

  <!-- Introduzione: esempio + scelta file -->
  <div class="import-intro" *ngIf="importView === 'INTRO'">
    <input #importFileInput type="file" hidden
           accept=".xlsx,.xls,.csv"
           (change)="onImportFileSelected($event)">

    <div class="import-intro-template">
      <div class="d-flex align-items-center gap-3">
        <div class="import-intro-template-icon"><i class="fas fa-file-excel"></i></div>
        <div>
          <div class="fw-bold">Scarica l'Excel di esempio</div>
          <div class="small text-muted">Una sola colonna <b>Barcode</b>: una riga per ogni collo da aggiungere.</div>
        </div>
      </div>
      <button type="button" class="btn btn-outline-success bt-small" (click)="downloadImportTemplate()">
        <i class="fas fa-download me-2"></i>Scarica esempio
      </button>
    </div>

    <div class="import-intro-main">
      <div class="import-intro-main-icon"><i class="fas fa-file-import"></i></div>
      <div class="import-intro-title">Importa colli da Excel</div>
      <div class="import-intro-sub">
        I colli trovati vengono mostrati prima di essere aggiunti: potrai scegliere quali aggiungere al borderò.
      </div>
      <button type="button" class="btn btn-success btn-lg import-intro-btn" (click)="importFileInput.click()">
        <i class="fas fa-upload me-2"></i>Importa
      </button>
    </div>
  </div>

  <!-- Caricamento -->
  <div class="import-loading" *ngIf="importView === 'LOADING'">
    <div class="import-loading-icon">
      <i class="fas fa-file-excel"></i>
      <span class="import-loading-ring"></span>
    </div>
    <div class="import-loading-title">Caricamento Excel in corso…</div>
    <div class="import-loading-sub">
      <i class="fas fa-file me-1"></i>{{ importFileName }}
    </div>
    <div class="import-loading-bar"><span></span></div>
    <div class="import-loading-hint">Sto verificando i barcode e cercando i colli</div>
  </div>

  <!-- Anteprima -->
  <ng-container *ngIf="importView === 'PREVIEW'">
    <div class="items-summary-card import-summary-card">
      <div class="d-flex flex-wrap align-items-center gap-2">
        <div class="summary-title me-2">
          <i class="fas fa-file-import me-2"></i>
          <b>Colli trovati nell'Excel</b>
          <span class="text-muted ms-2 small">{{ importFileName }}</span>
        </div>
        <div class="d-flex flex-wrap gap-2 ms-auto" *ngIf="!importError">
          <span class="import-chip">Totale <b>{{ importTotalCount }}</b></span>
          <span class="import-chip import-chip--ok">
            <i class="fas fa-circle-check me-1"></i>OK <b>{{ importOkCount }}</b>
            <!-- I già presenti sono degli OK: badge incorporato -->
            <span class="import-chip-nested" *ngIf="importAlreadyOkCount > 0"
                  matTooltip="Di cui già presenti nel borderò">
              <i class="fas fa-circle-info me-1"></i>di cui già presenti <b>{{ importAlreadyOkCount }}</b>
            </span>
          </span>
          <span class="import-chip import-chip--warning"><i class="fas fa-triangle-exclamation me-1"></i>Da verificare <b>{{ importWarningCount }}</b></span>
          <span class="import-chip import-chip--error"><i class="fas fa-circle-xmark me-1"></i>Non aggiungibili <b>{{ importErrorCount }}</b></span>
        </div>
      </div>
      <div class="small text-muted mt-2" *ngIf="!importError && (importDuplicatesCount > 0 || importEmptyRowsCount > 0)">
        <i class="fas fa-circle-info me-1"></i>
        <span *ngIf="importDuplicatesCount > 0">{{ importDuplicatesCount }} barcode duplicati ignorati. </span>
        <span *ngIf="importEmptyRowsCount > 0">{{ importEmptyRowsCount }} righe vuote ignorate.</span>
      </div>
    </div>

    <div class="alert alert-danger mt-3 mb-0" *ngIf="importError">
      <i class="fas fa-triangle-exclamation me-2"></i>{{ importError }}
    </div>

    <ng-container *ngIf="!importError">
      <div class="d-flex align-items-center gap-2 mt-2">
        <button type="button" class="btn btn-outline-primary bt-small" (click)="selectAllImportRows()">
          <i class="fas fa-check-double me-2"></i>Seleziona tutto
        </button>
        <button type="button" class="btn btn-outline-secondary bt-small" (click)="deselectAllImportRows()">
          <i class="fas fa-ban me-2"></i>Deseleziona tutto
        </button>
        <label class="import-only-issues ms-auto">
          <input type="checkbox" class="form-check-input me-2" [(ngModel)]="importOnlyIssues">
          Mostra solo righe con segnalazioni
        </label>
      </div>

      <div class="items-list-scroll mt-2">
        <div class="items-list">
          <div class="item-row import-row"
               *ngFor="let r of importVisibleRows"
               [class.selected]="r.selected"
               [class.import-row--ok]="r.level === 'ok'"
               [class.import-row--warning]="r.level === 'warning'"
               [class.import-row--error]="r.level === 'error'"
               [class.import-row--disabled]="!r.selectable"
               (click)="toggleImportRow(r)">

            <div class="item-check">
              <input type="checkbox" class="form-check-input"
                     [checked]="r.selected"
                     [disabled]="!r.selectable"
                     (click)="$event.stopPropagation(); toggleImportRow(r)">
            </div>

            <div class="flex-grow-1 min-w-0">
              <div class="d-flex flex-wrap align-items-center gap-3">
                <span class="parcel-code">{{ r.item?.parcelCode || r.barcode }}</span>
                <span class="text-muted small" *ngIf="r.item?.parcelCode && r.item?.parcelCode !== r.barcode">
                  <i class="fas fa-barcode me-1"></i>{{ r.barcode }}
                </span>
                <span *ngIf="r.item?.urgencyCode" class="urgency-badge-item">
                  <span class="urgency-label">URGENTE</span>
                </span>
                <span class="import-status-pill ms-auto"
                      [class.import-status-pill--ok]="r.level === 'ok'"
                      [class.import-status-pill--warning]="r.level === 'warning'"
                      [class.import-status-pill--error]="r.level === 'error'">
                  <i class="fas"
                     [class.fa-circle-check]="r.level === 'ok'"
                     [class.fa-triangle-exclamation]="r.level === 'warning'"
                     [class.fa-circle-xmark]="r.level === 'error'"></i>
                  {{ r.level === 'ok' ? 'OK' : (r.level === 'warning' ? 'DA VERIFICARE' : 'NON AGGIUNGIBILE') }}
                </span>
              </div>

              <div class="import-meta small mt-1" *ngIf="r.item">
                <span><i class="fas fa-route me-1"></i>Tour: <b>{{ r.item.tourRoutingGroupName || '-' }}</b></span>
                <span><i class="fas fa-user me-1"></i>Cliente: <b>{{ r.item.clientAcronym || '-' }}</b></span>
                <span><i class="fas fa-location-dot me-1"></i>Regione: <b>{{ r.item.regionAcronym || '-' }}</b></span>
                <span><i class="fas fa-weight-hanging me-1"></i>Peso: <b>{{ r.item.weightKg ?? '-' }} kg</b></span>
                <span><i class="fas fa-cube me-1"></i>Volume: <b>{{ r.item.volumeM3 ?? '-' }} m³</b></span>
                <span *ngIf="r.item.parcelPalletType"><i class="fas fa-pallet me-1"></i>Tipo: <b>{{ r.item.parcelPalletType }}</b></span>
                <span><i class="fas fa-calendar me-1"></i>Affido: <b>{{ r.item.parcelDate ? (r.item.parcelDate | date:'dd/MM/yy HH:mm') : '-' }}</b></span>
                <span><i class="fas fa-truck me-1"></i>Consegna stimata: <b>{{ r.item.parcelEstimatedDeliveryDate ? (r.item.parcelEstimatedDeliveryDate | date:'dd/MM/yy HH:mm') : '-' }}</b></span>
              </div>

              <div class="import-messages mt-1">
                <div *ngFor="let m of r.messages" class="import-msg" [ngClass]="'import-msg--' + m.level">
                  <i class="fas me-1"
                     [class.fa-circle-check]="m.level === 'ok'"
                     [class.fa-circle-info]="m.level === 'info'"
                     [class.fa-triangle-exclamation]="m.level === 'warning'"
                     [class.fa-circle-xmark]="m.level === 'error'"></i>{{ m.text }}
                </div>
              </div>
            </div>
          </div>

          <div class="text-center text-muted py-4" *ngIf="importVisibleRows.length === 0">
            Nessuna riga da mostrare.
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
<div class="alert alert-light border small mt-2 mb-0" *ngIf="!canEdit && importView === 'NONE'">
  <i class="fas fa-lock me-2"></i>
  Borderò in sola lettura (stato: <b>{{ getStatusLabel() }}</b>).
</div>
</div>
<div class="popup-footer" *ngIf="step === 1 && mode === 'CREATE'">
  <div class="d-flex justify-content-end gap-2">
    <button type="button"
            class="btn btn-primary"
            (click)="goToItemsStep()"
            [disabled]="form.invalid || loadingCarriers || loadingItems || (linkedTripCarrierMismatch || carrierMismatchNeedsDecision)">
      <i class="fas fa-arrow-right me-2"></i>
      Avanti
    </button>
  </div>
</div>


<!-- Footer introduzione import -->
<div class="popup-footer" *ngIf="step === 2 && importView === 'INTRO'">
  <div class="d-flex justify-content-start">
    <button type="button" class="btn btn-secondary" (click)="cancelImport()">
      <i class="fas fa-arrow-left me-2"></i>Torna al borderò
    </button>
  </div>
</div>

<!-- Footer anteprima import -->
<div class="popup-footer" *ngIf="step === 2 && importView === 'PREVIEW'">
  <div class="d-flex justify-content-between align-items-center gap-2">
    <button type="button" class="btn btn-secondary" (click)="cancelImport()">
      <i class="fas fa-arrow-left me-2"></i>Torna al borderò
    </button>
    <div class="d-flex align-items-center gap-3">
      <span class="small text-muted" *ngIf="!importError">
        Selezionati <b>{{ importSelectedCount }}</b> · {{ importSelectedWeightKg | number:'1.0-2' }} kg
      </span>
      <button type="button" class="btn btn-success"
              *ngIf="!importError"
              [disabled]="importSelectedCount === 0"
              (click)="addImportedItems()">
        <i class="fas fa-plus me-2"></i>Aggiungi al borderò ({{ importSelectedCount }})
      </button>
    </div>
  </div>
</div>

<div class="popup-footer" *ngIf="step === 2 && importView === 'NONE'">
  <div class="d-flex justify-content-between gap-2" *ngIf="mode === 'CREATE'" >

    <button type="button" class="btn btn-secondary" (click)="backToForm()">
      <i class="fas fa-arrow-left me-2"></i>Indietro
    </button>

    <button type="button"
            class="btn btn-primary"
            (click)="confirmCreate()"
            [disabled]="selectedCount === 0 || (linkedTripCarrierMismatch || carrierMismatchNeedsDecision)">
      <i class="fas fa-save me-2"></i>
      Crea Borderò ({{ selectedCount }})
    </button>

  </div>

  <div class="d-flex justify-content-end gap-2" *ngIf="readOnly">
    <button type="button" class="btn btn-secondary" (click)="close()">
      <i class="fas fa-times me-2"></i>
      Chiudi
    </button>
  </div>

  <div class="d-flex justify-content-end gap-2"
      *ngIf="mode === 'EDIT' && !isDeclaringUnloadingEnd && !readOnly">
    <button type="button"
            class="btn btn-success"
            (click)="declareUnloadingEnd()"
            [disabled]="!canSave"
            *ngIf="loadingListType === 'ARRIVAL'">
      <i class="fas fa-check me-2"></i>
      Dichiara Fine Scarico
    </button>

    <button type="button"
            class="btn btn-primary"
            (click)="saveBordero()"
            [disabled]="!canSave || selectedCount === 0">
      <i class="fas fa-save me-2"></i>
      Salva Borderò ({{ selectedCount }})
    </button>
  </div>

  <div class="d-flex justify-content-between gap-2"
      *ngIf="mode === 'EDIT' && isDeclaringUnloadingEnd">

    <button type="button" class="btn btn-secondary" (click)="cancelDeclareUnloadingEnd()">
      <i class="fas fa-arrow-left me-2"></i>Indietro
    </button>

    <button type="button"
            class="btn btn-success"
            (click)="confirmDeclareUnloadingEnd()"
            [disabled]="!canSave">
      <i class="fas fa-check me-2"></i>Conferma
    </button>
  </div>

</div>



</div>